<template>
  <div>
    <v-btn
      absolute
      top
      right
      @click="togglePanel"
      x-small
      :color="'success'"
      class="btn-panel"
    >
      <v-icon>{{ showPanel ? 'mdi-chevron-double-right' : 'mdi-chevron-double-left' }}</v-icon>
    </v-btn>

    <v-row>
      <v-col :lg="showPanel ? 8 : 12">
        <v-tabs v-model="activeTab" background-color="transparent" color="primary">
          <v-tab>Requerimientos de Compra</v-tab>
          <v-tab>Requerimientos de Servicio</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card flat>
              <OrderPurcharseAttentionQuote
                ref="purchaseAttention"
                :model="true"
                @selected="onSelected($event, 1)"
              ></OrderPurcharseAttentionQuote>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <ServiceAttentionQuote
                ref="serviceAttention"
                :model="true"
                @selected="onSelected($event, 3)"
              ></ServiceAttentionQuote>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <!-- Quote Request Dialog -->
        <v-dialog v-if="showQuoteEdit" v-model="showQuoteEdit" width="90%" persistent transition="dialog-bottom-transition">
          <QuoteRequest :items="itemsCard" @close="showQuoteEdit = false" @saved="onQuoteSaved"></QuoteRequest>
        </v-dialog>
      </v-col>

      <!-- Side Panel - Carrito de Cotización -->
      <v-col lg="4" v-if="showPanel" style="padding-top: 60px;">
        <transition name="slide-fade">
          <v-card class="cart-card elevation-4" rounded="lg">
            <!-- Header con gradiente -->
            <v-card-title class="cart-header white--text py-4">
              <v-icon left color="white" size="28">mdi-cart</v-icon>
              <span class="text-h6 font-weight-bold">Carrito de Cotización</span>
            </v-card-title>

            <!-- Resumen Visual -->
            <v-card-text class="pa-4" v-if="itemsCard.length > 0">
              <v-card outlined class="summary-card mb-3">
                <v-card-text class="py-2 px-3">
                  <v-row dense align="center">
                    <v-col cols="6">
                      <div class="summary-item">
                        <v-icon small color="primary" class="mr-1">mdi-format-list-numbered</v-icon>
                        <span class="text-caption font-weight-medium">{{ itemsCard.length }} {{ itemsCard.length === 1 ? 'item' : 'items' }}</span>
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="summary-item">
                        <v-icon small :color="cartType === 1 ? 'blue' : 'purple'" class="mr-1">
                          {{ cartType === 1 ? 'mdi-package-variant' : 'mdi-tools' }}
                        </v-icon>
                        <span class="text-caption font-weight-medium">{{ cartType === 1 ? 'Compra' : 'Servicio' }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Items como Cards -->
              <div class="items-container">
                <v-card
                  v-for="(item, index) in itemsCard"
                  :key="index"
                  outlined
                  class="item-card mb-3"
                  hover
                >
                  <v-card-text class="pa-3">
                    <div class="d-flex justify-space-between align-start mb-2">
                      <div class="flex-grow-1">
                        <div class="d-flex align-center mb-1">
                          <v-chip
                            x-small
                            :color="item.TypeOrder === 1 ? 'blue' : 'purple'"
                            text-color="white"
                            class="mr-2"
                          >
                            {{ item.TypeOrder === 1 ? 'COMPRA' : 'SERVICIO' }}
                          </v-chip>
                          <span class="text-caption grey--text">{{ item.ReqDocumentNumber }}</span>
                        </div>
                        <div class="item-description font-weight-medium">
                          {{ item.DerDescription }}
                        </div>
                      </div>
                      <v-btn
                        icon
                        x-small
                        color="error"
                        @click="removeItem(index)"
                        class="ml-2"
                      >
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </div>
                    
                    <v-divider class="my-2"></v-divider>
                    
                    <div class="d-flex justify-space-between text-caption">
                      <span v-if="item.DerNumLine" class="grey--text">
                        <v-icon x-small class="mr-1">mdi-format-list-numbered</v-icon>
                        Línea: {{ item.DerNumLine }}
                      </span>
                      <span class="font-weight-medium">
                        <v-icon x-small class="mr-1">mdi-counter</v-icon>
                        {{ item.DerQuantity }} {{ item.UnitMeasurement }}
                      </span>
                    </div>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Botón Generar Cotización -->
              <v-btn
                block
                x-large
                color="success"
                class="generate-btn mt-4"
                elevation="2"
                @click="showQuoteEditDialog()"
              >
                <v-icon left>mdi-rocket-launch</v-icon>
                Generar Cotización
              </v-btn>
            </v-card-text>

            <!-- Estado Vacío -->
            <v-card-text v-else class="pa-6">
              <div class="empty-state text-center">
                <v-icon size="80" color="grey lighten-1">mdi-cart-outline</v-icon>
                <div class="text-h6 mt-4 mb-2 grey--text text--darken-1">Carrito Vacío</div>
                <p class="text-body-2 grey--text mb-4">
                  Selecciona requerimientos de las tablas para comenzar a crear tu cotización
                </p>
                <v-icon color="grey lighten-1" class="pulse-icon">mdi-arrow-left</v-icon>
                <p class="text-caption grey--text">Usa los checkboxes de la izquierda</p>
              </div>
            </v-card-text>
          </v-card>
        </transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import QuoteRequest from "@/views/Logistics/Quote/QuoteRequest.vue";
import OrderPurcharseAttentionQuote from "@/views/Logistics/OrderStore/OrderPurcharseAttentionQuote.vue";
import ServiceAttentionQuote from "@/views/Logistics/Requirement/ServiceAttentionQuote.vue";

export default {
  name: "QuoteAttention",
  components: {
    QuoteRequest,
    OrderPurcharseAttentionQuote,
    ServiceAttentionQuote
  },
  data: () => ({
    activeTab: 0,
    showPanel: true,
    showQuoteEdit: false,
    itemsCard: [], // Stores selected items for the quote
  }),
  mounted() {
    this.loadFromLocalStorage();
    setTimeout(() => {
        if (this.$refs.purchaseAttention) this.$refs.purchaseAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 1));
        if (this.$refs.serviceAttention) this.$refs.serviceAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 3));
    }, 1500); // Esperar 1.5s a que carguen los datos (ajustable)
  },
  methods: {
    onSelected(items, type) {
      const incomingItems = items || [];
      
      // Handle Type Mismatch
      if (this.itemsCard.length > 0) {
        const currentType = this.itemsCard[0].TypeOrder;
        if (currentType !== type) {
             // Mismatch
             if (incomingItems.length > 0) {
                 // User trying to add items of another type
                 const existingTypeName = currentType === 1 ? 'Compra' : 'Servicio';
                 const newTypeName = type === 1 ? 'Compra' : 'Servicio';
                 
                 this.$fun.alert(
                   `No se pueden mezclar requerimientos de ${existingTypeName} y ${newTypeName}. ` +
                   `El carrito actual contiene requerimientos de ${existingTypeName}. ` +
                   `¿Desea limpiar el carrito y agregar los nuevos ítems de ${newTypeName}?`,
                   'question'
                 ).then((result) => {
                    if (result.value) {
                        this.itemsCard = incomingItems.map(i => ({...i, TypeOrder: type}));
                        this.saveToLocalStorage();
                        if (!this.showPanel) this.togglePanel();
                    } else {
                        // User cancelled. Revert simple selection in child by re-applying itemsCard
                         this.$nextTick(() => {
                            if (type === 1 && this.$refs.purchaseAttention) this.$refs.purchaseAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 1));
                            if (type === 3 && this.$refs.serviceAttention) this.$refs.serviceAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 3));
                         });
                    }
                 });
             }
             // If incomingItems is empty, it's just the other tab reporting "I have nothing", which is expected. Ignore.
             return;
        }
      }
      
      // Type Match or Cart Empty -> Sync
      // Only show panel if we went from 0 to >0 items
      const wasEmpty = this.itemsCard.length === 0;
      this.itemsCard = incomingItems.map(i => ({...i, TypeOrder: type}));
      this.saveToLocalStorage();
      
      if (wasEmpty && this.itemsCard.length > 0 && !this.showPanel) {
          this.togglePanel();
      }
    },
    clearCart() {
      this.itemsCard = [];
      this.saveToLocalStorage();
      // Sync clearing with children
      this.$nextTick(() => {
        if (this.$refs.purchaseAttention) this.$refs.purchaseAttention.selectItems([]);
        if (this.$refs.serviceAttention) this.$refs.serviceAttention.selectItems([]);
      });
    },
    onQuoteSaved() {
      // Refresh the active component's grid
      if (this.activeTab === 0) {
        if (this.$refs.purchaseAttention) {
             this.$refs.purchaseAttention.refresh();
             setTimeout(() => {
                 this.$refs.purchaseAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 1));
             }, 1000);
        }
      } else {
        if (this.$refs.serviceAttention) {
            this.$refs.serviceAttention.refresh();
            setTimeout(() => {
                 this.$refs.serviceAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 3));
             }, 1000);
        }
      }

      // Limpiar el carrito después de guardar exitosamente
      this.clearCart(); 
      this.showQuoteEdit = false;
    },
    removeItem(index) {
      this.itemsCard.splice(index, 1);
      this.saveToLocalStorage();
      // Sync removal with children
      this.$nextTick(() => {
        if (this.activeTab === 0 && this.$refs.purchaseAttention) {
             this.$refs.purchaseAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 1));
        }
        if (this.activeTab === 1 && this.$refs.serviceAttention) {
             this.$refs.serviceAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 3));
        }
      });
    },
    showQuoteEditDialog() {
      if (this.itemsCard.length > 0) {
        this.showQuoteEdit = true;
      } else {
        this.$fun.alert("No ha seleccionado ningún registro", "warning");
      }
    },
    togglePanel() {
      this.showPanel = !this.showPanel;
    },
    saveToLocalStorage() {
      localStorage.setItem("quoteAttentionItems", JSON.stringify(this.itemsCard));
    },
    loadFromLocalStorage() {
      const stored = localStorage.getItem("quoteAttentionItems");
      if (stored) {
        try {
          this.itemsCard = JSON.parse(stored);
        } catch (e) {
          console.error("Error loading localStorage", e);
        }
      }
    }
  },
  computed: {
    cartType() {
      return this.itemsCard.length > 0 ? this.itemsCard[0].TypeOrder : null;
    }
  },
  watch: {
    activeTab(val) {
        this.$nextTick(() => {
            if (val === 0 && this.$refs.purchaseAttention) {
                this.$refs.purchaseAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 1));
            }
            if (val === 1 && this.$refs.serviceAttention) {
                this.$refs.serviceAttention.selectItems(this.itemsCard.filter(x => x.TypeOrder === 3));
            }
        });
    }
  }
};
</script>

<style scoped>
/* Transición slide-fade */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

/* Botón de toggle */
.btn-panel {
  margin-right: -16px;
  margin-top: -3px;
  z-index: 100;
}

/* Cart Card */
.cart-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

/* Header con gradiente */
.cart-header {
  background: linear-gradient(135deg, #4ba2a2 0%, #2d7a7a 100%) !important;
  border-radius: 0 !important;
}

/* Summary Card */
.summary-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px !important;
  border: 2px solid #dee2e6 !important;
}

.summary-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Items Container */
.items-container {
  max-height: calc(100vh - 400px);
  overflow-y: auto;
  padding-right: 4px;
}

.items-container::-webkit-scrollbar {
  width: 6px;
}

.items-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.items-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.items-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Item Cards */
.item-card {
  border-radius: 12px !important;
  border: 2px solid #e0e0e0 !important;
  transition: all 0.3s ease;
  animation: slideIn 0.3s ease;
}

.item-card:hover {
  border-color: #4ba2a2 !important;
  box-shadow: 0 4px 12px rgba(75, 162, 162, 0.2) !important;
  transform: translateY(-2px);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.item-description {
  font-size: 14px;
  line-height: 1.4;
  color: #2c3e50;
}

/* Generate Button */
.generate-btn {
  font-size: 16px !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px !important;
  text-transform: uppercase !important;
  border-radius: 12px !important;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);
  }
}

.generate-btn:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
}

/* Empty State */
.empty-state {
  padding: 40px 20px;
}

.pulse-icon {
  animation: pulseArrow 1.5s ease-in-out infinite;
}

@keyframes pulseArrow {
  0%, 100% {
    opacity: 0.5;
    transform: translateX(0);
  }
  50% {
    opacity: 1;
    transform: translateX(-10px);
  }
}

/* Responsive */
@media (max-width: 960px) {
  .items-container {
    max-height: 400px;
  }
  
  .cart-card {
    margin-bottom: 20px;
  }
}

/* Smooth transitions */
* {
  transition: background-color 0.2s ease, color 0.2s ease;
}
</style>
